import * as React from "react"
import { ContentfulIcon } from "./ContentfulIcon"
import { ShopifyIcon } from "./ShopifyIcon"
import { DatoCMSIcon } from "./DatoCMSIcon"
import { MDIcon } from "./MDIcon"
import { MDXIcon } from "./MDXIcon"
import { GatsbyIcon } from "./GatsbyIcon"
import { CosmicJsIcon } from "./CosmicJsIcon"

export const siteTypeIcons: Record<string, JSX.Element> = {
  Shopify: <ShopifyIcon />,
  Blog: <MDIcon />,
  Default: <GatsbyIcon />,
}

export const cmsVendorIcons: Record<string, JSX.Element> = {
  CONTENTFUL: <ContentfulIcon />,
  DATOCMS: <DatoCMSIcon />,
  MDX: <MDXIcon />,
  COSMICJS: <CosmicJsIcon />,
  MD: <MDIcon />,
  SHOPIFY: <ShopifyIcon />,
}
